import React from 'react';
import cn from 'classnames';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LazyContext from '@wix/da-shared-react/pkg/LazyLoadingImage/LazyContext';

import withSectionFetchSpinner from '../../../decorators/withSectionFetchSpinner';
import { ModuleType } from '../../../../types/modules';
import Zone, { ZoneGroup } from '../../Layout/Zone';
import { ZoneType } from '../../../../types/layout';

import { AboutMeBox } from '../../UserWidgets/AboutMe';
import { WatchersBox, WatchingBox } from '../../UserWidgets/WatchedDeviants';
import DonationsBox from '../../UserWidgets/Donations';
import FeaturedDeviation from '../../UserWidgets/FeaturedDeviation';
import FeaturedPost from '../../UserWidgets/FeaturedPost';
import StripExhibitionist from '../../UserWidgets/StripExhibitionist';
import TallExhibitionist from '../../UserWidgets/TallExhibitionist';
import { GroupsAdminBox, GroupsMemberBox } from '../../UserWidgets/Groups';
import ProfileCommentsBox from '../../UserWidgets/ProfileComments';
import DeviousnessBox from '../../UserWidgets/Deviousness';
import CustomBox from '../../UserWidgets/Custom';
import FeedBox from '../../UserWidgets/Feed';
import AdBox from '../../UserWidgets/Ad';
import TiersBox from '../../UserWidgets/Tiers/PromotionBox';
import WixPortfolioCallToAction from '../../UserWidgets/WixPortfolioCallToAction';
import withFeatureFlags from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import { WithFeatureFlagsProps } from '@wix/da-shared-react/pkg/MediaPopup/_hocs/withFeatureFlags';
import MultiTop from '../../UserWidgets/MultiTop/MultiTop';

import s from './HomeSection.scss';

const mapModuleTypeToWidgetComponent = {
  [ModuleType.ABOUT]: AboutMeBox,
  [ModuleType.EXHIBITIONIST]: TallExhibitionist,
  [ModuleType.FEATURED_DEVIATION]: FeaturedDeviation,
  [ModuleType.FEATURED_POST]: FeaturedPost,
  [ModuleType.WATCHERS]: WatchersBox,
  [ModuleType.WATCHING]: WatchingBox,
  [ModuleType.GROUPS_ADMIN]: GroupsAdminBox,
  [ModuleType.GROUPS_MEMBER]: GroupsMemberBox,
  [ModuleType.COMMENTS]: ProfileCommentsBox,
  [ModuleType.DONATIONS]: DonationsBox,
  [ModuleType.DEVIOUSNESS]: DeviousnessBox,
  [ModuleType.FEED]: FeedBox,
  [ModuleType.CUSTOM]: CustomBox,
  [ModuleType.TIERS]: TiersBox,
};

export interface Props extends WithFeatureFlagsProps {
  isMobile?: boolean;
  isOwner?: boolean;
}

class HomeSection extends React.Component<Props> {
  render() {
    const isMobile = this.props.isMobile;
    const zoneProps = {
      className: s['zone'],
      mapModuleTypeToWidgetComponent,
    };
    const multiTop = this.props.flags.includes('up_multi_top');
    const profile_mobile_heading = this.props.flags.includes(
      'profile_mobile_heading'
    );
    return (
      <div
        className={cn(
          s['root'],
          profile_mobile_heading && s['profile_mobile_heading']
        )}
      >
        {multiTop && <MultiTop />}
        <LazyContext.Provider value={true}>
          {isMobile
            ? this.renderOneColumn(zoneProps)
            : this.renderTwoColumns(zoneProps)}
        </LazyContext.Provider>
      </div>
    );
  }

  renderTwoColumns(zoneProps) {
    const { flags } = this.props;
    const isMegabox = flags.includes('megabox');
    const isRemovableAboutMe = flags.includes('removable_aboutme');
    return (
      <>
        <div className={s['zone-top']}>
          <ZoneGroup disableTopAddWidget={isMegabox}>
            {isMegabox && (
              <Zone
                type={ZoneType.MEGA_BAR}
                mapModuleTypeToWidgetComponent={{
                  [ModuleType.CUSTOM]: CustomBox,
                }}
                columnType={ModuleType.CUSTOM}
                direction="row"
              />
            )}
            <Zone
              type={ZoneType.TOP_BAR}
              mapModuleTypeToWidgetComponent={{
                [ModuleType.EXHIBITIONIST]: StripExhibitionist,
                [ModuleType.TIERS]: TiersBox,
              }}
            />
          </ZoneGroup>
        </div>
        <div className={s['flex-wrap']}>
          <div className={s['zone-column-left']}>
            <ZoneGroup disableTopAddWidget={true}>
              <Zone type={ZoneType.TOP_LEFT} {...zoneProps} />
              <Zone type={ZoneType.BOTTOM_LEFT} {...zoneProps} />
            </ZoneGroup>
          </div>
          <div className={s['zone-column-right']}>
            <WixPortfolioCallToAction />
            <ZoneGroup>
              <Zone
                type={ZoneType.TOP_RIGHT}
                {...zoneProps}
                locked={!isRemovableAboutMe}
              />
              {this.props.isOwner && <AdBox />}
            </ZoneGroup>
            <ZoneGroup>
              <Zone type={ZoneType.MID_RIGHT} {...zoneProps} />
              <Zone type={ZoneType.BOTTOM_RIGHT} {...zoneProps} />
            </ZoneGroup>
          </div>
        </div>
      </>
    );
  }

  renderOneColumn(zoneProps) {
    const { flags } = this.props;
    const isMegabox = flags.includes('megabox');
    const isRemovableAboutMe = flags.includes('removable_aboutme');
    return (
      <div className={s['zone-wrapper']}>
        <div className={s['zone-top']}>
          {isMegabox && (
            <ZoneGroup
              disableTopAddWidget={isMegabox}
              className={s['zone-group']}
            >
              <Zone
                type={ZoneType.MEGA_BAR}
                mapModuleTypeToWidgetComponent={{
                  [ModuleType.CUSTOM]: CustomBox,
                }}
                columnType={ModuleType.CUSTOM}
                direction="row"
              />
            </ZoneGroup>
          )}
          <ZoneGroup className={s['zone-group']}>
            <WixPortfolioCallToAction />
            <Zone
              type={ZoneType.TOP_RIGHT}
              {...zoneProps}
              locked={!isRemovableAboutMe}
            />
          </ZoneGroup>
        </div>
        <ZoneGroup className={s['zone-group']}>
          <Zone type={ZoneType.TOP_BAR} {...zoneProps} />
          <Zone type={ZoneType.TOP_LEFT} {...zoneProps} />
          <Zone type={ZoneType.MID_RIGHT} {...zoneProps} />
          <Zone type={ZoneType.BOTTOM_LEFT} {...zoneProps} />
          <Zone type={ZoneType.BOTTOM_RIGHT} {...zoneProps} />
        </ZoneGroup>
      </div>
    );
  }
}

export default withFeatureFlags(
  withMobileContext(withSectionFetchSpinner(HomeSection))
);
